import { css } from 'styled-components';

const surface = /*#__PURE__*/css(["background-clip:padding-box;border-radius:", ";box-shadow:", ";outline:none;z-index:", ";border:none;"], ({
  theme
}) => theme.tooltip.radius, ({
  theme
}) => theme.popover.boxShadow, ({
  theme
}) => theme.popover.zIndex);

export { surface as s };
//# sourceMappingURL=surface-BUCERZjl.js.map
